<script setup>
import { Head, Link } from '@inertiajs/vue3';
import FrontLayout from '@/Layouts/FrontLayout.vue';
import PageHero from '@/Components/Front/PageHero.vue';

const props = defineProps({
    setting: Object,
});
</script>

<template>
    <FrontLayout 
        :setting="setting"
        title="Kebijakan Privasi Sewa Mobil Banyuwangi"
        metaDescription="Kebijakan privasi layanan sewa mobil Banyuwangi dan rental mobil Banyuwangi dari Gotransport. Perlindungan data pribadi pelanggan."
    >
        <Head>

            <meta name="description" content="Kebijakan privasi layanan sewa mobil Banyuwangi dan rental mobil Banyuwangi dari Gotransport. Perlindungan data pribadi pelanggan." />
        </Head>

        <PageHero 
            title="Kebijakan Privasi"
            subtitle="Perlindungan data pribadi pelanggan dalam layanan rental mobil Gotransport"
            :breadcrumbs="[
                { label: 'Beranda', url: '/' },
                { label: 'Kebijakan Privasi' }
            ]"
        />

        <section class="py-12 md:py-16 bg-white dark:bg-gray-900 min-h-[500px]">
             <div class="container mx-auto px-4 lg:px-6 xl:px-8 max-w-4xl">
                 <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
                    <div class="p-4">
                         <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-6 border-b border-gray-100 dark:border-gray-700 pb-4">Kebijakan Privasi Sewa & Rental Mobil Banyuwangi</h2>
                         
                         <div class="space-y-8 text-gray-600 dark:text-gray-300 leading-relaxed">
                             <div>
                                 <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Pengumpulan Informasi</h3>
                                 <p>Gotransport mengumpulkan informasi personal yang Anda berikan saat melakukan pemesanan rental mobil, termasuk nama, nomor telepon, alamat, dan informasi identitas yang diperlukan.</p>
                             </div>

                             <div>
                                 <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Penggunaan Informasi</h3>
                                 <p class="mb-2">Informasi yang kami kumpulkan digunakan untuk:</p>
                                 <ul class="list-disc pl-5 space-y-1">
                                     <li>Memproses dan mengelola pemesanan rental mobil</li>
                                     <li>Berkomunikasi dengan pelanggan terkait layanan</li>
                                     <li>Meningkatkan kualitas layanan kami</li>
                                     <li>Memenuhi kewajiban hukum</li>
                                 </ul>
                             </div>

                             <div>
                                 <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Perlindungan Data</h3>
                                 <p>Kami berkomitmen melindungi informasi pribadi Anda dengan menerapkan langkah-langkah keamanan yang sesuai untuk mencegah akses, penggunaan, atau pengungkapan yang tidak sah.</p>
                             </div>

                             <div>
                                 <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Pembagian Informasi</h3>
                                 <p>Kami tidak akan menjual, menyewakan, atau membagikan informasi pribadi Anda kepada pihak ketiga tanpa persetujuan Anda, kecuali diwajibkan oleh hukum.</p>
                             </div>

                             <div>
                                 <h3 class="text-xl font-semibold text-gray-800 dark:text-white mb-3">Hubungi Kami</h3>
                                 <p>Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, silakan hubungi kami melalui halaman kontak.</p>
                             </div>
                         </div>
                         
                         <div class="mt-10 pt-8 border-t border-gray-100 dark:border-gray-700 text-center">
                             <Link href="/contact" class="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-full transition-colors">
                                 Hubungi Kami
                             </Link>
                         </div>
                    </div>
                 </div>
             </div>
        </section>
    </FrontLayout>
</template>
